'use client';

import { MfeLoad } from '@carvana/microfrontend';
import { MfeReactComponent } from '@carvana/microfrontend-react';
import { background } from '@carvana/ds-styles';
import { useEffect } from 'react';
import styled from 'styled-components';

const BasicFooter = styled.div`
  background-color: ${background.strong};
  height: 610px;
`;

interface FooterComponentProps {
  environment?: string;
  withoutProvider?: boolean;
}

const Footer = () => {
  useEffect(() => {
    MfeLoad({
      files: [
        [
          'FooterModule',
          [
            {
              component: 'default',
              browser: true,
              default: {
                file: 'index.js',
                manifest: `${
                  process.env.CARVANA_APP_CDN_URL
                }/footer/module/assets-manifest.json?v=${Date.now()}`
              }
            }
          ]
        ]
      ]
    });
  }, []);

  const renderFooter = ({
    Component
  }: {
    Component: React.ComponentType<FooterComponentProps>;
  }) => <Component environment={process.env.CARVANA_APP_ENVIRONMENT} withoutProvider />;

  return (
    <MfeReactComponent
      component="default"
      module="FooterModule"
      environment={process.env.CARVANA_APP_ENVIRONMENT}
      loading={<BasicFooter />}
      withoutProvider
    >
      {renderFooter}
    </MfeReactComponent>
  );
};

export default Footer;
